import { megaMenu } from '../../utils/mega-menu';

const headerMenu = document.querySelector('.header-menu');
const headerMenuActiveItem = document.querySelector('.header-menu__item--active');
const headerMenuDot = document.querySelector('.header-menu__dot');

let isDirty = false;

const updateDotPosition = (x = null) => {
  if (x === null) {
    if (headerMenuActiveItem) {
      x = headerMenuActiveItem.offsetLeft - headerMenu.offsetLeft;
      headerMenuDot.classList.remove('header-menu__dot--hidden');
    } else {
      x = 0;
      headerMenuDot.classList.add('header-menu__dot--hidden');
    }
  } else {
    isDirty = true;
    headerMenuDot.classList.remove('header-menu__dot--hidden');
  }

  const transform = `translate3d(${x}px, 0, 0)`;

  headerMenuDot.style.webkitTransform = transform;
  headerMenuDot.style.msTransform = transform;
  headerMenuDot.style.transform = transform;

  if (!headerMenuDot.classList.contains('header-menu__dot--initialized')) {
    setTimeout(() => headerMenuDot.classList.add('header-menu__dot--initialized'), 400);
  }
};

if (headerMenu) {
  // Update dot position
  updateDotPosition();
  window.addEventListener('resize', () => updateDotPosition());
  window.addEventListener('load', () => !isDirty && updateDotPosition());

  // Mega menu toggles
  headerMenu.querySelectorAll('.header-menu__item-button').forEach((button) => {
    button.addEventListener('click', () => {
      megaMenu.toggle(button.nextElementSibling);
    });
  });

  // Set hover classes
  headerMenu.querySelectorAll('.header-menu__item').forEach((item) => {
    item.addEventListener('mouseenter', () => updateDotPosition(item.offsetLeft - headerMenu.offsetLeft));
  });

  // Remove hover classes
  headerMenu.addEventListener('mouseleave', () => updateDotPosition());
}